// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PersonalDashboard_ProjectFragmentDoc, PersonalDashboard_UserEventParentTypeFragmentDoc, PersonalDashboard_MarketFragmentDoc, PersonalDashboard_DevelopmentFragmentDoc, PersonalDashboard_CohortFragmentDoc, PersonalDashboard_InternalUserFragmentDoc } from '../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PersonalDashboardsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PersonalDashboardsPageQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, development?: { __typename?: 'Development', id: string } | null | undefined }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, userEventParentTypes: Array<{ __typename?: 'UserEventParentType', id: string, name: string }>, currentInternalUser?: { __typename?: 'InternalUser', id: string } | null | undefined };

export type AssignedToDosQueryVariables = Types.Exact<{
  assignee?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type AssignedToDosQuery = { __typename?: 'Query', toDos: Array<{ __typename?: 'ToDo', id: string }> };

export type TeamMembersProjectsQueryVariables = Types.Exact<{
  teamMembers: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type TeamMembersProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }> };


export const PersonalDashboardsPageDocument = gql`
    query PersonalDashboardsPage {
  internalUsers {
    ...PersonalDashboard_InternalUser
  }
  cohorts {
    ...PersonalDashboard_Cohort
  }
  developments {
    ...PersonalDashboard_Development
  }
  markets {
    ...PersonalDashboard_Market
  }
  userEventParentTypes {
    ...PersonalDashboard_UserEventParentType
  }
  currentInternalUser {
    id
  }
}
    ${PersonalDashboard_InternalUserFragmentDoc}
${PersonalDashboard_CohortFragmentDoc}
${PersonalDashboard_DevelopmentFragmentDoc}
${PersonalDashboard_MarketFragmentDoc}
${PersonalDashboard_UserEventParentTypeFragmentDoc}`;

/**
 * __usePersonalDashboardsPageQuery__
 *
 * To run a query within a React component, call `usePersonalDashboardsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalDashboardsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalDashboardsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalDashboardsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>(PersonalDashboardsPageDocument, options);
      }
export function usePersonalDashboardsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>(PersonalDashboardsPageDocument, options);
        }
// @ts-ignore
export function usePersonalDashboardsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>;
export function usePersonalDashboardsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonalDashboardsPageQuery | undefined, PersonalDashboardsPageQueryVariables>;
export function usePersonalDashboardsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>(PersonalDashboardsPageDocument, options);
        }
export type PersonalDashboardsPageQueryHookResult = ReturnType<typeof usePersonalDashboardsPageQuery>;
export type PersonalDashboardsPageLazyQueryHookResult = ReturnType<typeof usePersonalDashboardsPageLazyQuery>;
export type PersonalDashboardsPageSuspenseQueryHookResult = ReturnType<typeof usePersonalDashboardsPageSuspenseQuery>;
export type PersonalDashboardsPageQueryResult = Apollo.QueryResult<PersonalDashboardsPageQuery, PersonalDashboardsPageQueryVariables>;
export const AssignedToDosDocument = gql`
    query AssignedToDos($assignee: [ID!]) {
  toDos(filter: {assignee: $assignee, status: [UP_NEXT, IN_PROGRESS]}) {
    id
  }
}
    `;

/**
 * __useAssignedToDosQuery__
 *
 * To run a query within a React component, call `useAssignedToDosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedToDosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedToDosQuery({
 *   variables: {
 *      assignee: // value for 'assignee'
 *   },
 * });
 */
export function useAssignedToDosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AssignedToDosQuery, AssignedToDosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssignedToDosQuery, AssignedToDosQueryVariables>(AssignedToDosDocument, options);
      }
export function useAssignedToDosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssignedToDosQuery, AssignedToDosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssignedToDosQuery, AssignedToDosQueryVariables>(AssignedToDosDocument, options);
        }
// @ts-ignore
export function useAssignedToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssignedToDosQuery, AssignedToDosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignedToDosQuery, AssignedToDosQueryVariables>;
export function useAssignedToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignedToDosQuery, AssignedToDosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignedToDosQuery | undefined, AssignedToDosQueryVariables>;
export function useAssignedToDosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignedToDosQuery, AssignedToDosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AssignedToDosQuery, AssignedToDosQueryVariables>(AssignedToDosDocument, options);
        }
export type AssignedToDosQueryHookResult = ReturnType<typeof useAssignedToDosQuery>;
export type AssignedToDosLazyQueryHookResult = ReturnType<typeof useAssignedToDosLazyQuery>;
export type AssignedToDosSuspenseQueryHookResult = ReturnType<typeof useAssignedToDosSuspenseQuery>;
export type AssignedToDosQueryResult = Apollo.QueryResult<AssignedToDosQuery, AssignedToDosQueryVariables>;
export const TeamMembersProjectsDocument = gql`
    query TeamMembersProjects($teamMembers: [ID!]!) {
  projects(
    filter: {status: [ACTIVE, COMPLETED, UNDER_WARRANTY], teamMembers: $teamMembers}
  ) {
    ...PersonalDashboard_Project
  }
}
    ${PersonalDashboard_ProjectFragmentDoc}`;

/**
 * __useTeamMembersProjectsQuery__
 *
 * To run a query within a React component, call `useTeamMembersProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersProjectsQuery({
 *   variables: {
 *      teamMembers: // value for 'teamMembers'
 *   },
 * });
 */
export function useTeamMembersProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables> & ({ variables: TeamMembersProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>(TeamMembersProjectsDocument, options);
      }
export function useTeamMembersProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>(TeamMembersProjectsDocument, options);
        }
// @ts-ignore
export function useTeamMembersProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>;
export function useTeamMembersProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersProjectsQuery | undefined, TeamMembersProjectsQueryVariables>;
export function useTeamMembersProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>(TeamMembersProjectsDocument, options);
        }
export type TeamMembersProjectsQueryHookResult = ReturnType<typeof useTeamMembersProjectsQuery>;
export type TeamMembersProjectsLazyQueryHookResult = ReturnType<typeof useTeamMembersProjectsLazyQuery>;
export type TeamMembersProjectsSuspenseQueryHookResult = ReturnType<typeof useTeamMembersProjectsSuspenseQuery>;
export type TeamMembersProjectsQueryResult = Apollo.QueryResult<TeamMembersProjectsQuery, TeamMembersProjectsQueryVariables>;